<template>
  <div id="g-page" >
    <table border="0" class="screen" >
      <tr>
        <td id="screen-row1" colspan="1"> 
          <!--MOVES THE VIEW BELOW THE MAIN MENU-->
        </td>
      </tr>
      <!-- TITLE -->
      <tr>
        <td class="screen-table-td">
          <div v-if="isMobile">
            <table class="section-table" border="0" align="center">
              <tr>
                <td id="page-title-left" class="radius-single-left-field-left-top radius-single-right-field-right-top" >
                  {{ $t("appt.title1")}}<!--Medical Appointments-->
                </td>
                <td id="page-title-right" class="radius-single-left-field-left-bottom radius-single-right-field-right-bottom">
                  {{ $t("appt.title2")}}<!--Below is the complete list of medical appointments currently on file for you. These appointments include both upcoming visits and past consultations.-->
                </td>
              </tr>
            </table>
          </div>
          <div v-else>
            <table class="section-table" border="0" align="center">
              <tr>
                <td id="page-title-left" class="radius-single-left-field-left-top radius-single-left-field-left-bottom" >
                  {{ $t("appt.title1")}}<!--Medical Appointments-->
                </td>
                <td id="page-title-right" class="radius-single-right-field-right-top radius-single-right-field-right-bottom">
                  {{ $t("appt.title2")}}<!--Below is the complete list of medical appointments currently on file for you. These appointments include both upcoming visits and past consultations.-->
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <!-- APPOINTMENT VIEW -->
      <tr>
        <td class="screen-table-td">
          <div style="height:10px;" />
          <table class="section-table" border="0" align="center">
            <tr v-if="isMobile"> <!-- MOBILE -->
              <td colspan="1">                
                <div v-if="appointments.length == 0" >
                  <table width="100%" border="0">
                    <tr>
                      <td class="no-appointments-found radius-single-left-field-left-top radius-single-right-field-right-top radius-single-left-field-left-bottom radius-single-right-field-right-bottom">
                        {{ $t("appt.noAppointments") }}<!-- No appointments found-->
                      </td>
                    </tr>
                  </table>
                </div>
                <div v-else style="width:100%" >
                 
                    <table width="100%" border="0">
                      <thead>
                        <tr>
                          <td class="field-td-header radius-single-left-field-left-top radius-single-right-field-right-top"></td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="appointment in appointments" :key="appointment.appointmentId">
                          <td class="field-td-left" colspan="1"> 
                            <span style="font-weight:bold">{{ $t("appt.headerMember") }}: <!--Member:--></span>{{ appointment.member }}
                            <br>
                            <span style="font-weight:bold">{{ $t("appt.headerPhysician") }}: <!--Physician--></span>{{ appointment.physician }} 
                            <br>
                            <span style="font-weight:bold">{{ $t("appt.headerStatus") }}: <!--Appointment Status--></span>{{ appointment.appointmentStatus }} 
                            <br>
                            <span style="font-weight:bold">{{ $t("appt.headerDate") }}: <!-- Date: --></span>{{ formatToShortDate(appointment.appointmentDate) }} }} 
                            <br>
                            <span style="font-weight:bold">{{$t("appt.headerTime") }}: <!--Time:--></span>{{ appointment.appointmentTime }} 
                            <br>
                            <span style="font-weight:bold">{{ $t("appt.headerDuration") }}: <!--Duration:--></span>{{ appointment.appointmentDuration }} 
                            <br>
                            <span style="font-weight:bold">{{$t("appt.headerType")}}: <!--Type:--></span>{{ appointment.appointmentType }} 
                            <br>
                            <span style="font-weight:bold">{{$t("appt.headerLocation")}}: <!--Location:--></span>{{ appointment.appointmentLocation }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- couldn't get this crap to work as a tfoot, so fuck it-->
                    <table style="width:100%">
                      <tr>
                          <td class="appointment-td-footer radius-single-left-field-left-bottom radius-single-right-field-right-bottom"></td>
                      </tr>
                    </table>
                </div>
              </td>
            </tr>
            <tr v-else><!-- DESKTOP-->
              <td colspan="8">  
                <div v-if="appointments.length == 0">
                  <table width="100%" border="0">
                    <tr>
                      <td class="no-appointments-found radius-single-left-field-left-top radius-single-right-field-right-top radius-single-left-field-left-bottom radius-single-right-field-right-bottom">
                        {{ $t("appt.noAppointments") }}
                      </td><!-- No appointments found-->
                    </tr>
                  </table>
                </div>
                <div v-else>
                  <div style="width:100%" >
                    <table width="100%" border="0">
                      <thead>
                        <tr>
                          <th class="field-td-header radius-single-left-field-left-top">{{ $t("appt.headerMember") }}</th>
                          <th class="field-td-header">{{ $t("appt.headerPhysician") }}</th>
                          <th class="field-td-header">{{ $t("appt.headerStatus") }}</th>
                          <th class="field-td-header">{{ $t("appt.headerDate") }}</th>
                          <th class="field-td-header">{{ $t("appt.headerTime") }}</th>
                          <th class="field-td-header">{{ $t("appt.headerDuration") }}</th>
                          <th class="field-td-header">{{ $t("appt.headerType") }}</th>
                          <th class="field-td-header radius-single-right-field-right-top">{{ $t("appt.headerLocation") }}</th>
                        </tr>
                      </thead>
                      <tr v-for="appointment in appointments" :key="appointment.appointmentId" >
                        <td class="field-td">{{ appointment.member }}</td>
                        <td class="field-td">{{ appointment.physician }}</td>
                        <td class="field-td">{{ appointment.appointmentStatus }}</td>
                        <td class="field-td">{{ formatToShortDate(appointment.appointmentDate)}}</td>
                        <td class="field-td">{{ appointment.appointmentTime }}</td>
                        <td class="field-td">{{ appointment.appointmentDuration }}</td>
                        <td class="field-td">{{ appointment.appointmentType }}</td>
                        <td class="field-td">{{ appointment.appointmentLocation }}</td>
                      </tr>
                      <tfoot>
                        <tr>
                          <td class="appointment-td-footer radius-single-left-field-left-bottom"></td>
                          <td colspan="6" class="appointment-td-footer"></td>
                          <td class="appointment-td-footer radius-single-right-field-right-bottom"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            
          </table>
        </td>
      </tr>
      
      <!-- LOADING -->
      <tr>
        <td class="screen-table-td">
          <div id="loading" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <div style="height:100px;"/>
                        <img src="../../../assets/images/working.gif" style="background-color:transparent;height:40px" >
                        <div style="height:100px;"/>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>   
      </tr>
      <div style="height:20px"/>
    </table>
  </div>
</template>

<script>

import messageBox from '.././common/message-box'
const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
import moment from 'moment'

export default {
  name: 'appointments',
  data() {
    return {
      appointments: [],
      appointmentsLength:0,
      isMobile:false
    }
  },
  methods: {
    formatToShortDate(date)
    {
      return moment(date).format('MM-DD-YYYY');
    },
    load() {
      
      SUPPORT.showServiceMenus();
      
      document.getElementById('menuAppointments').classList.add('is-hidden');
  
      var loading = document.getElementById("loading");
      loading.style.display = "block";

      API.readAppointments(window.sessionKey, this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          //this.input.isLoading = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          this.appointments = response.data.appointments;
          this.appointmentsLength = response.data.length;
          loading.style.display = "none";
        }
      }).catch( e =>
      {
        loading.style.display = "none";
        this.$generalMessage( messageBox, e );            
      })
    }
  },
  
  mounted () {
    
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);

    this.load();
  },
  created() {
    if (screen.width <= 1023) {
        this.isMobile = true;
      } else {
        this.isMobile = false
      }
  }, 
  
}

</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

// BEGIN SHARED STYLES
p {
  white-space: pre;
}
.border-dots
{
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:red !important;
}
/* .disabled {
  background-color:darkgray;
}
.enabled {
  background-color: white;
} */
// END SHARED STYLES

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  .data-canvas
  {
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
  }
  .screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
  }  
  #screen-row1
  {
    margin-top:10px;
    height:100%; 
  }
  .screen-table-td
  {
    margin:auto;
  }
  .section-table
  {
    width:96%;
  }
  #page-title-left
  {
    width:100%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
    text-align: center;
  }
  #page-title-right
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .field-td-header
  {
    width:100%;
    height:25px;
    background-color:#343F68;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    text-align: left;
    margin-bottom:0px;
    padding-top:0px;
    padding-left:5px;
    vertical-align: left;
  }
  .field-td-left
  {
    width:100%;
    //height:20px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    //font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    //margin-left: 5px;
    vertical-align:middle !important;
    text-align: left;
    //padding-left: 5px;
    border-bottom: #343F68 2px solid ;
  }
  .field-td
  {
    height:25px;
    width:100%;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .no-appointments-found
  {
    height:25px;
    width:100%;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:25px;
    vertical-align:middle;
    text-align: center;
  }
  .appointment-td-footer
  {
    height:25px;
    width:100%;
    background-color:#343F68;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:10px;
    margin-bottom:25px;
    vertical-align:middle;
    text-align: center;
  }
  /* .test-td-test-item
  {
    height:35px;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    padding-left:5px;
    margin-bottom:0px;
    vertical-align:top;
    text-align:left;
  } */
  .instruction-field
  {
    //height:25px;
    vertical-align: top;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
    //padding-left: 10%;
    //padding-right: 10%;
  }
  .section-border-top
  {
    border-top-style: solid;
    border-top-color:#4682B4 ;
    border-top-width: 3px;
  }
  // ******* CORNER SUPPORT *******
  .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    //overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    //overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    //overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    //overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 
  // ******* END CORNER SUPPORT *******

}
//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  .data-canvas
  {
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
  }
  #screen-row1
  {
    height:50px; 
  }
  .screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
  }
  .screen-table-td
  {
    margin:auto;
  }
  .section-table
  {
    width:98%;
  }
  #page-title-left
  {
    width:20%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    padding-left:15px;
    margin-bottom:0px;
    vertical-align: middle;
  }
  #page-title-right
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .field-td-header
  {
    width:12.5% !important;
    height:25px;
    background-color:#343F68;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    padding-top:10px;
    text-align: center;
    margin-bottom:0px;
    vertical-align: left;
  }
  .field-td-left
  {
    width:12.5%;
    height:25px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    padding-left: 15px;
    vertical-align:middle;
    text-align: left;
  }
  .field-td
  {
    
    height:25px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
    border-bottom: silver 1px dotted ;
  }
  .no-appointments-found
  {
    height:25px;
    width:12.5%;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .appointment-td-footer
  {
    height:25px;
    //width:100%;
    background-color:#343F68;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  /* .test-td-test-item
  {
    height:25px;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  } */
  .instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
    padding-left: 10%;
    padding-right: 10%;
  }

  .section-border-top
  {
    border-top-style: solid;
    border-top-color:#4682B4 ;
    border-top-width: 3px;
  }

  // ******* CORNER SUPPORT *******
  .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    //overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    //overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 
  // ******* END CORNER SUPPORT *******
}
</style>